<template>
  <transition name="ui-overlay">
    <div
      v-if="show"
      class="fixed inset-0 z-90 flex items-center justify-center bg-black/40"
      @click.self="close"
    >
      <slot />
    </div>
  </transition>
</template>

<script setup lang="ts">
/** UiOverlay — Vuetify <v-overlay> replacement.
 * Dual Vue 2 / Vue 3 compatible. */
import { computed } from 'vue'

const props = defineProps<{ modelValue?: boolean; value?: boolean }>()
const emit = defineEmits<(e: 'update:modelValue', v: boolean) => void>()
// Vue 2 defaults absent Boolean props to `false` (not `undefined`), so `??`
// won't fall through when v-model binds to `value` and `modelValue` is the
// default `false`. Use `||` so the default `false` falls through to `value`.
const show = computed(() => props.modelValue || props.value || false)
function close() {
  emit('update:modelValue', false)
}
</script>

<style scoped>
.ui-overlay-enter-active,
.ui-overlay-leave-active {
  transition: opacity 0.2s;
}
.ui-overlay-enter-from,
.ui-overlay-leave-to {
  opacity: 0;
}
</style>
